<script>
import { Container } from "./styled";
export default {
  props: {
    search: String,
    items: {
      type: Array,
      default: () => [],
    },
    disableSearchWhenEmpty: {
      type: Boolean,
      default: true,
    },
  },
  components: { Container },
  methods: {
    handleSearch(value) {
      this.$emit("handleSearch", value);
    },
  },
};
</script>
